/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconFilterPause = createReactComponent("filter-pause", "IconFilterPause", [
  [
    "path",
    {
      d: "M12.97 19.677l-3.97 1.323v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227h16v2.172a2 2 0 0 1 -.586 1.414l-4.414 4.414v1.5",
      key: "svg-0"
    }
  ],
  ["path", { d: "M17 17v5", key: "svg-1" }],
  ["path", { d: "M21 17v5", key: "svg-2" }]
]);

export { IconFilterPause as default };
//# sourceMappingURL=IconFilterPause.js.map
